import axios from "axios";
import authHeader from "@/services/utils/auth-header";
import StringUtils from "@/services/utils/StringUtils";

const API_URL = '/OppPortal/api/v1/portals/';

class PortalDataService {
    countAll() {
        return axios.get(API_URL + "count", {headers: authHeader()});
    }

    count(disabled, published) {
        return axios.get(API_URL + `count?disabled=${disabled}&published=${published}`, {headers: authHeader()});
    }

    countByManager(disabled, published, email) {
        return axios.get(API_URL + `count?disabled=${disabled}&published=${published}&emailManager=${email}`, {headers: authHeader()});
    }

    getAll() {
        return axios.get(API_URL + "all", {headers: authHeader()});
    }

    get(name) {
        return axios.get(API_URL + `portal/${name}`, {headers: authHeader()});
    }

    create(data) {
        return axios.post(API_URL + "portal", data, {headers: authHeader()});
    }

    update(id, data) {
        return axios.put(API_URL + `portal/${id}`, data, {headers: authHeader()});
    }

    delete(name) {
        return axios.delete(API_URL + `portal/${name}`, {headers: authHeader()});
    }

    findByClient(clientId) {
        return axios.get(API_URL + `all?client=${clientId}`, {headers: authHeader()});
    }

    findByName(name) {
        return axios.get(API_URL + `all?name=${name}`, {headers: authHeader()});
    }

    findByManager(email) {
        return axios.get(API_URL + `all?emailManager=${email}`, {headers: authHeader()});
    }

    duplicate(id) {
        return axios.get(API_URL + `duplicate/${id}`, {headers: authHeader()});
    }

    export(name, withClient) {
        return axios.get(API_URL + `export/${name}?withClient=${withClient}`, {headers: authHeader()});
    }

    disable(id, name, disable, message) {
        if (message == null || StringUtils.methods.isEmpty(message)){
            return axios.get(API_URL + `disable/${id}/${name}?disable=${disable}`, {headers: authHeader()});
        }
        const authHeaders = authHeader();
        let headers = {
            "Content-Type": "text/plain",
            "Authorization": authHeaders.Authorization
        }
        return axios.post(API_URL + `disable/${id}/${name}?disable=${disable}`, message, {headers: headers});
    }
}

export default new PortalDataService();